'use strict';

export default typeof FormData !== 'undefined' ? FormData : null;



//////////////////
// WEBPACK FOOTER
// E:/项目/渠道推广统计/statisticsLizu/node_modules/axios/lib/platform/browser/classes/FormData.js
// module id = null
// module chunks = 